<template>
<div class="main mt15 p34">
	<div class="my-title">{{info.productName}}</div>
	<div class="recognize-table mt10">
		<Button type="info" @click="add" v-if="handle.indexOf('add')>-1&&info.quoteVersion!=1">添加</Button>
		<slot name="thead"></slot>
		<e-table :list="list">
			<el-table-column prop="no" label="序号" width="70" align="center" fixed></el-table-column>
			<el-table-column prop="scheme" label="保障方案" show-overflow-tooltip width="180"></el-table-column>
			<el-table-column prop="premium" label="保费（元）" width="120"></el-table-column>
			<template v-if="type=='person'">
				<el-table-column prop="insuredPersonName" label="姓名" width="100"></el-table-column>
				<el-table-column prop="idCard" label="证件号码" width="190"></el-table-column>
				<el-table-column prop="gender" label="性别" width="70"></el-table-column>
				<el-table-column prop="age" label="年龄" width="70"></el-table-column>
			</template>
			<template  v-if="type=='car'">
				<el-table-column prop="seatingCapacity" label="座位数" width="80"></el-table-column>
				<el-table-column prop="carNumber" label="车牌号" width="120"></el-table-column>
				<el-table-column prop="engineNumber" label="发动机号" width="190"></el-table-column>
				<el-table-column prop="frameNumber" label="车架号" width="180"></el-table-column>
			</template>
			<el-table-column prop="effectiveStatusDesc" label="保障状态" width="120"></el-table-column>
			<el-table-column prop="effectiveDateStart" label="保障起期" width="120"></el-table-column>
			<el-table-column prop="effectiveDateEnd" label="保障止期" width="120"></el-table-column>
			<el-table-column prop="remark" label="备注" show-overflow-tooltip width="160"></el-table-column>
			<el-table-column label="操作" fixed="right" width="130">
				<template slot-scope="scope">
					<a v-if="scope.row.operation=='INIT'&&handle.indexOf('edit')>-1" @click="edit(scope.row)">编辑</a>
					<a v-if="scope.row.operation=='INIT'&&handle.indexOf('replace')>-1" @click="replace(scope.row)">替换</a>
					<a v-if="scope.row.operation=='INIT'&&handle.indexOf('refund')>-1" @click="refund(scope.row)">减人</a>
					<a v-if="scope.row.operation!='INIT'&&scope.row.operation!='REMOVE'" @click="recall(scope.row,scope.$index)">{{scope.row.operation=='ADD'?'删除':'撤回'}}</a>
					<a v-if="scope.row.operation=='REMOVE'" @click="recall(scope.row,scope.$index)">取消减人</a>
				</template>
			</el-table-column>
		</e-table>
		<slot name="file"></slot>
	</div>
	<div class="mt10 center">
		<Button type="success" @click="sub" :disabled="!canSub">提交信息</Button>
	</div>
	
	<Modal
		v-model="confirmShow"
		title="信息变更"
		width="400px"
		:mask-closable="false">
		<Form :label-width="160" class="info">
			<FormItem :label="`姓名变化${typeName}数量：`" v-if="confirmInfo.editSum">
				{{confirmInfo.editSum}}
			</FormItem>
			<FormItem :label="`替换${typeName}数量：`" v-if="confirmInfo.replaceSum">
				{{confirmInfo.replaceSum}}
			</FormItem>
			<FormItem :label="`退出${typeName}数量：`" v-if="confirmInfo.removeSum">
				{{confirmInfo.removeSum}}
			</FormItem>
			<FormItem :label="`新增${typeName}数量：`" v-if="confirmInfo.addSum">
				{{confirmInfo.addSum}}
			</FormItem>
			<FormItem :label-width="20">
				本次编辑{{typeName}}，合计需缴纳金额{{confirmInfo.needQuotePremiumSum}}元
			</FormItem>
		</Form>
		<template slot="footer">
			<Button type="text" @click="confirmShow=false">取消</Button>
			<Button type="primary" @click="confirmSub" :loading="confirmLoading">确定</Button>
		</template>
	</Modal>
	<TrackNotice />
</div>
</template>
<script>
// 后端
// INIT("原始投保"),
// ADD("新增"),
// REPLACE("替换"),
// EDIT("编辑"),
// REMOVE("退保");
import TrackNotice from '@/components/common/TrackNotice.vue';
import track from "@/mixin/track";
import eTable from '@/components/common/eTable'
export default {
	components: { TrackNotice,eTable },
	mixins:[track],
	props:{
		// info:{
		// 	type: Object,
		// 	default(){
		// 		return {}
		// 	}
		// },
		type:{
			type:String,
			default(){
				return 'person'
			}
		},
		handle:{
			type:Array,
			default(){
				return ['edit','replace','refund','add']
			}
		},
		fileUrl:{
			type:String,
			default:'NO'
		},
		typeName:{
			type:String,
			default:'人员' // 类型名称，目前有人员和车辆两种
		},
		dataKey:{
			type:String,
			default:'idCard' // 唯一标识，用于校验重复数据
		},
		
	},
	data () {
		let effectiveDateStart=new Date().getTime()+3600*1000*24
		return {
			info:{},
			originalList:[],// 原始数据
			id:this.$route.params.id,
			effectiveDateStart:this.formatDate(effectiveDateStart),
			list:[],
			addShow:false,
			addForm:{},
			addFormRules:{
				insurantName:{required:true,message:'请填写姓名',trigger:'blur'},
				insurantCertificateNumber:{required:true,message:'请填写证件号',trigger:'blur'},
				jobType:{required:true,message:'请选择职业/工种',trigger:'change'},
				insuranceScheme:{required:true,message:'请选择计划',trigger:'change'},
			},
			editShow:false,
			editForm:{},
			editFormRules:{
				insurantName:{required:true,message:'请填写姓名',trigger:'blur'},
			},
			replaceShow:false,
			replaceData:{},
			replaceForm:{},
			replaceFormRules:{
				insurantName:{required:true,message:'请填写姓名',trigger:'blur'},
				insurantCertificateNumber:{required:true,message:'请填写证件号',trigger:'blur'},
			},
			confirmShow:false,
			confirmInfo:{},
			confirmLoading:false,
			subList:[],
			jobTypeList:[],
			schemeList:[]
		}
	},
	computed: {
		canSub(){
			let list=this.list.filter(item=>{
				return item.operation!='INIT'
			})
			let hasNonRemoveOperations = list.some(item => item.operation !== 'REMOVE')
			return list.length>0 && (!hasNonRemoveOperations || this.fileUrl)
		},
		tableColumns(){
			return this.columns.concat([])
		},
	},
	created () {
		this.getInfo();
	},
	mounted(){
		// 回溯 开始录制
		this.track_is_new = true;
		this.$nextTick(()=>{
			this.trackInit();
		})
	},
	methods:{
		/*获取保单信息*/
		getInfo () {
			this.$axios.get('/broker/insurance/policy/detail.dst',{
				insurancePolicyId:this.id
			}).then(res=>{
				// 不展示退保人员
				let list=res.subjectMatter.filter(item=>{
					return item.operation!='REMOVE'
				})
				list = list.map(item=>{
					item.operation='INIT'
					return item
				})
				this.info=res;
				this.info.applicantInfo=res.applicantList&&res.applicantList.length>0?res.applicantList[0]:{}
				this.$emit('set-info',res)
				this.originalList=this.jsonCopy(list);
				this.list=list;
				this.$emit('set-data',this.list)
			});
		},
		// 获取修改数据
		getHandleList(list){
			return this.$axios.post('/broker/insurance/endorse/apply.json.dst',{
				insurancePolicyId:this.id,
				subjectMatter:list
			}).then(res=>{
				let originalList=this.jsonCopy(this.originalList)
				res.subjectMatter.forEach(item=>{
					if(item.operation=='ADD'){
						originalList.push(item)
					}else if(item.operation=='REPLACE') {
						let index=originalList.findIndex(fItem=>{
							return fItem.no==item.no
						})
						originalList.splice(index,1,item)
					} else if (item.operation=='EDIT'){
						let index=originalList.findIndex(fItem=>{
							return fItem.no==item.no
						})
						originalList.splice(index,1,item)
					} else if (item.operation=='REMOVE'){
						let index=originalList.findIndex(fItem=>{
							return fItem.no==item.no
						})
						originalList.splice(index,1,item)
					}
				})
				this.list=originalList
				this.$emit('set-data',originalList)
			});
		},
		// 撤回
		recall(row,index){
			let text=''
			if(row.operation=='ADD'){
				text=`确定删除新增${this.typeName}？`
			}else if(row.operation=='EDIT'){
				text=`确定撤回编辑${this.typeName}姓名？`
			}else if(row.operation=='REMOVE'){
				text=`确定取消该名员工退出保障计划吗？`
			}else if(row.operation=='REPLACE'){
				text=`确定撤回替换${this.typeName}？`
			}
			this.confirm(text,()=>{
				if(row.operation=='ADD'){
					this.list.splice(index,1)
				}else{
					let originalItem=this.originalList.find(item=>{
						return item.no==row.no
					})
					let idx=this.list.findIndex(item=>{
						return item.no==row.no
					})
					if(originalItem&&idx>-1){
						this.list.splice(idx,1,originalItem)
					}
					let addIndex=this.list.findIndex(item=>{
						return item[this.dataKey]==originalItem[this.dataKey]&&item.operation=='ADD'
					})
					if(addIndex>-1){
						this.list.splice(addIndex,1)
					}
				}
			})
		},
		// 添加
		add() {
			this.$emit('add')
		},
		// 修改名字
		edit(row){
			this.$emit('edit',row)
		},
		// 退保
		refund(row) {
			this.$emit('refund',row)
		},
		// 打开替换
		replace(row) {
			this.$emit('replace',row)
		},
		// 提交
		sub() {
			let list=this.list.filter(item=>{
				return item.operation!='INIT'
			})
			this.$axios.post('/broker/insurance/endorse/applyStats.json',{
				insurancePolicyId:this.id,
				subjectMatter:list
			}).then(res=>{
				this.confirmInfo=res;
				this.confirmShow=true;
			});
		},
		// 确认跳转
		confirmSub() {
			this.confirmLoading=true;
			let list=this.list.filter(item=>{
				return item.operation!='INIT'
			})
			this.$axios.post('/broker/insurance/endorse/confirm.json',{
				insurancePolicyId:this.id,
				subjectMatter:list,
				subjectMatterUrls:this.fileUrl=='NO'?'':this.fileUrl,
				premium:this.confirmInfo.needQuotePremiumSum
			}).then(res=>{
				// 批单号
				this.$axios.post('/broker/order/detail',{
					orderNo: res
				}).then(async respon=>{
					// if(respon){
					// 	// 回溯 停止录制
					// 	await this.stopRecord({
					// 		session_key:sessionStorage.track_session_key,
					// 		policy_id: respon.endorseNo
					// 	});
					// }
					this.confirmLoading=false;
					if(this.confirmInfo.needQuotePremiumSum>0){
						// 跳转支付
						window.location.replace(`/common.html#/common-pay/${res}`)
					}else if(this.confirmInfo.needQuotePremiumSum==0||this.confirmInfo.needQuotePremiumSum<0){
						// this.confirmShow=false
						// 跳订单详情
						window.location.replace(`/haierProduct.html#/my/order-detail/${res}/common`)
						// 返回保单
						// this.$router.back();
					}else{
						// 跳转我的积分
						window.location.replace('/ac.html#/my-new/list/storage-v/point')
					}
				})
			}).catch(res=>{
				this.confirmLoading=false;
			});
		}
	}
}
</script>
<style scoped lang="less">
.mb0{
	margin-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/common/EditContainer.vue